
/**
 * SEO 配置 - models (العربية)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - مولد فيديو الذكاء الاصطناعي الرائد | WeryAI',
        description: 'Google Veo 3.1: نموذج فيديو الذكاء الاصطناعي الرائد مع صوت أصلي والتحكم في الإطارات.',
        keywords: 'Google Veo 3.1, فيديو الذكاء الاصطناعي, مولد فيديو, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 توليد فيديو الذكاء الاصطناعي عالي | WeryAI',
        description: 'جرب Veo 3 على WeryAI. نتائج عالية الجودة.',
        keywords: 'Veo 3, Google Veo, فيديو الذكاء الاصطناعي, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast توليد فيديو الذكاء الاصطناعي فائق | WeryAI',
        description: 'جرب Veo 3 Fast على WeryAI. نتائج عالية الجودة وسريعة.',
        keywords: 'Veo 3 Fast, فيديو الذكاء الاصطناعي السريع, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - مولد فيديو الذكاء الاصطناعي الواقعي | WeryAI',
        description: 'جرب Sora 2 على WeryAI. نتائج عالية الجودة.',
        keywords: 'Sora 2, OpenAI Sora, فيديو الذكاء الاصطناعي, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - مولد فيديو الذكاء الاصطناعي | WeryAI',
        description: 'جرب WeryAI Video 1.0 لإنشاء فيديوهات سينمائية بالذكاء الاصطناعي.',
        keywords: 'WeryAI Video 1.0, فيديو الذكاء الاصطناعي, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - مولد صور AI أصلي | WeryAI',
        description: 'استخدم WeryAI Image 2 لتوليد صور AI أصلية مذهلة! النموذج الرائد مع تحكم متقدم بالأنماط. رصيد مجاني، بدون بطاقة.',
        keywords: 'WeryAI Image 2, مولد صور AI أصلي, صور AI رائدة, جودة استوديو AI, WeryAI Image مجاني, كيفية استخدام WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'مجاني Grok 2 - مولد صور xAI | WeryAI',
        description: 'استخدم Grok 2 على WeryAI لتوليد صور AI إبداعية! نموذج xAI مع مرونة فنية وأنماط فريدة. رصيد مجاني، بدون بطاقة.',
        keywords: 'Grok 2, Grok AI, مولد صور xAI, فن AI, صور AI إبداعية, Grok 2 مجاني, كيفية استخدام Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 مولد الصور أحدث نموذج صور AI | WeryAI',
        description: 'Nano Banana 2 مدعوم بـ Gemini مع معرفة عالمية وبحث في الوقت الفعلي. إنشاء صور دقيقة ومذهلة بسرعة فائقة وقيمة لا تُضاهى.',
        keywords: 'Nano Banana 2, Google AI, Gemini, توليد الصور, عرض النص, اتساق متعدد المواضيع, 4K, WeryAI',
        og_title: 'مولد صور Nano Banana 2 | WeryAI',
        og_description: 'Nano Banana 2 مدعوم بـ Gemini مع فهم عميق للعالم وبحث في الوقت الفعلي، وينتج صورًا جميلة ودقيقة.',
        twitter_title: 'مولد صور Nano Banana 2 | WeryAI',
        twitter_description: 'Nano Banana 2 مدعوم بـ Gemini مع فهم عميق للعالم وبحث في الوقت الفعلي، وينتج صورًا جميلة ودقيقة.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'مولد صور ذكاء اصطناعي Nano Banana 2',
        twitterImageAlt: 'مولد صور ذكاء اصطناعي Nano Banana 2',
    },
    kling_ai: {
        title: 'Kling AI - مولد فيديو الذكاء الاصطناعي السينمائي | WeryAI',
        description: 'جرب Kling AI على WeryAI. نتائج عالية الجودة.',
        keywords: 'Kling AI, فيديو الذكاء الاصطناعي, WeryAI',
    },
    runway_ai: {
        title: 'Runway AI - مولد ومحرر فيديو الذكاء الاصطناعي | WeryAI',
        description: 'جرب Runway AI على WeryAI. نتائج عالية الجودة.',
        keywords: 'Runway AI, فيديو الذكاء الاصطناعي, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 - مولد فيديو الذكاء الاصطناعي | WeryAI',
        description: 'جرب Hailuo 2.3 على WeryAI. نتائج عالية الجودة.',
        keywords: 'Hailuo 2.3, فيديو الذكاء الاصطناعي, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI - مولد فيديو الذكاء الاصطناعي المتقدم | WeryAI',
        description: 'جرب Hailuo AI على WeryAI. نتائج عالية الجودة.',
        keywords: 'Hailuo AI, فيديو الذكاء الاصطناعي, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - مولد رسوم متحركة الذكاء الاصطناعي | WeryAI',
        description: 'جرب Pika 2.2 على WeryAI. نتائج عالية الجودة.',
        keywords: 'Pika 2.2, رسوم متحركة الذكاء الاصطناعي, WeryAI',
    },
    seedance: {
        title: 'Seedance مولد فيديو الرقص والحركة بالذكاء الاصطناعي | WeryAI',
        description: 'جرب Seedance على WeryAI. نتائج واقعية واحترافية.',
        keywords: 'Seedance, فيديو الذكاء الاصطناعي, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - مولد فيديو AI بمستوى المخرج | WeryAI',

        description: 'أنشئ فيديوهات AI بمستوى المخرج مع Werydance 2.0: مراجع متعددة الأنماط، اتساق سردي، ومحاكاة فيزيائية. مجاناً على WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, مولد فيديو AI, فيديو مستوى المخرج, فيديو متعدد الوسائط, محاكاة فيزيائية, مزامنة شفاه, نص إلى فيديو, فيديو AI مجاني, WeryAI',

        og_title: 'Werydance 2.0 - مولد فيديو AI بمستوى المخرج | WeryAI',

        og_description: 'أنشئ فيديوهات AI بمستوى المخرج مع Werydance 2.0: مراجع متعددة الأنماط، اتساق سردي، ومحاكاة فيزيائية. مجاناً على WeryAI.',

        twitter_title: 'Werydance 2.0 - مولد فيديو AI بمستوى المخرج | WeryAI',

        twitter_description: 'أنشئ فيديوهات AI بمستوى المخرج مع Werydance 2.0: مراجع متعددة الأنماط، اتساق سردي، ومحاكاة فيزيائية. مجاناً على WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'مجاني Nano Banana Pro - مولد صور AI | WeryAI',
        description: 'استخدم Nano Banana Pro على WeryAI لصور AI بأعلى دقة! ينافس Midjourney في الجودة. رصيد مجاني، بدون بطاقة.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google صور AI, صور AI بالاستدلال, 4K صور AI, Nano Banana Pro مجاني, كيفية استخدام Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'مجاني Nano Banana - مولد صور AI | WeryAI',
        description: 'استخدم Nano Banana على WeryAI لإنشاء صور AI بسهولة! نموذج AI متعدد الاستخدامات وسريع. رصيد مجاني، بدون بطاقة.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google صور AI, مولد AI سريع, اتساق الشخصيات, Nano Banana مجاني, كيفية استخدام Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'مجاني FLUX - جرّب مولد صور الذكاء الاصطناعي | WeryAI',
        description: 'استخدم FLUX على WeryAI لتوليد صور AI مذهلة! من فريق Stable Diffusion بجودة بصرية استثنائية. رصيد مجاني، بدون بطاقة.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, مولد صور AI, نص إلى صورة, فن AI, FLUX مجاني, كيفية استخدام FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'مجاني FLUX Kontext - محرر صور AI احترافي | WeryAI',
        description: 'استخدم FLUX Kontext على WeryAI لتحرير صور AI احترافي! دقة فائقة وطباعة متقدمة وتحرير متعدد الخطوات. رصيد مجاني، بدون بطاقة.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, محرر صور AI, صور AI احترافية, طباعة AI, FLUX Kontext مجاني, كيفية استخدام FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'مجاني Imagen 4 - مولد صور AI من Google | WeryAI',
        description: 'استخدم Google Imagen 4 على WeryAI لإنشاء صور AI واقعية! تحكم متنوع بالأنماط وتوليد نص دقيق. رصيد مجاني، بدون بطاقة.',
        keywords: 'Imagen 4, Google Imagen, مولد صور AI Google, نص إلى صورة, AI واقعي, Imagen مجاني, كيفية استخدام Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'مجاني Qwen Image - نموذج صور AI من Alibaba | WeryAI',
        description: 'استخدم Qwen Image على WeryAI لتوليد فن AI متعدد اللغات! نموذج مفتوح المصدر من Alibaba مع عرض نص متفوق. رصيد مجاني، بدون بطاقة.',
        keywords: 'Qwen Image, Alibaba AI, صور AI مفتوحة المصدر, عرض نص متعدد اللغات, Qwen Image مجاني, كيفية استخدام Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'مجاني Wan AI - مولد صور Alibaba | WeryAI',
        description: 'استخدم Wan AI على WeryAI لصور AI عالية الدقة! نموذج Alibaba مع اتباع دقيق للتعليمات وعرض واقعي. رصيد مجاني، بدون بطاقة.',
        keywords: 'Wan AI, Wan 2.5, مولد صور AI Alibaba, نص إلى صورة, AI واقعي, Wan AI مجاني, كيفية استخدام Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'مجاني Seedream 4.0 - ByteDance صور AI | WeryAI',
        description: 'استخدم Seedream 4.0 على WeryAI لتوليد صور AI فائقة السرعة! نموذج ByteDance مع أنماط فنية متنوعة. رصيد مجاني، بدون بطاقة.',
        keywords: 'Seedream, Seedream 4.0, ByteDance صور AI, صور AI سريعة, أنماط فنية AI, Seedream مجاني, كيفية استخدام Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'مجاني Dreamina 4.0 - AI صور متعدد الوسائط | WeryAI',
        description: 'استخدم Dreamina 4.0 على WeryAI لإنشاء صور AI متعددة الوسائط! رسم إلى صورة ونقل الأسلوب ودمج الشخصيات. رصيد مجاني، بدون بطاقة.',
        keywords: 'Dreamina 4.0, ByteDance صور AI, صور AI متعددة الوسائط, رسم إلى صورة, نقل الأسلوب, Dreamina مجاني, كيفية استخدام Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'مجاني Seedream 4.5 - ByteDance صور AI | WeryAI',
        description: 'استخدم Seedream 4.5 على WeryAI لتوليد صور AI رائدة! الأحدث من ByteDance مع طباعة دقيقة ودمج متعدد الصور. رصيد مجاني، بدون بطاقة.',
        keywords: 'Seedream 4.5, ByteDance صور AI, نموذج رائد, عرض طباعي, دمج صور متعددة, Seedream 4.5 مجاني, كيفية استخدام Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 نموذج توليد صور الذكاء الاصطناعي | WeryAI',
        description: 'Seedream 5.0 هو تحفة ByteDance في مجال الذكاء الاصطناعي البصري بجودة 8K أصلية وفهم دلالي فائق وتكوين متعدد الموضوعات وعرض نصوص 2.0. جربه مجانًا على WeryAI.',
        keywords: 'Seedream 5.0, ByteDance, مولد صور ذكاء اصطناعي, مولد صور 8K, توليد صور الذكاء الاصطناعي, تحويل النص إلى صورة, فهم دلالي, تكوين متعدد الموضوعات, عرض نصوص, WeryAI',
        og_title: 'مولد صور Seedream 5.0 | WeryAI',
        og_description: 'Seedream 5.0 هو تحفة ByteDance في مجال الذكاء الاصطناعي البصري بجودة 8K أصلية وفهم دلالي فائق وتكوين متعدد الموضوعات وعرض نصوص 2.0. جربه مجانًا على WeryAI.',
        twitter_title: 'مولد صور Seedream 5.0 | WeryAI',
        twitter_description: 'Seedream 5.0 هو تحفة ByteDance في مجال الذكاء الاصطناعي البصري بجودة 8K أصلية وفهم دلالي فائق وتكوين متعدد الموضوعات وعرض نصوص 2.0. جربه مجانًا على WeryAI.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'مولد صور ذكاء اصطناعي Seedream 5.0',
        twitterImageAlt: 'مولد صور ذكاء اصطناعي Seedream 5.0',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - مولد رسومات متجهة احترافي بالذكاء الاصطناعي | WeryAI',
        description: 'Recraft V4 Vector هو مولد رسومات متجهة احترافي بالذكاء الاصطناعي من Recraft.ai يولد متجهات SVG قابلة للتحرير مع تحجيم بدون فقدان وطباعة دقيقة والتحكم في نمط العلامة التجارية. جربه مجانًا على WeryAI الآن.',
        keywords: 'Recraft V4 Vector, توليد متجهات الذكاء الاصطناعي, مولد SVG, متجه حقيقي, تصميم شعار, أيقونات UI, رسم توضيحي متجه, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'مجاني Midjourney - جرّب مولد الفن AI | WeryAI',
        description: 'استخدم Midjourney على WeryAI لإنشاء صور AI فنية! مشهور بجمالياته المذهلة وجودة الإضاءة. رصيد مجاني، بدون بطاقة.',
        keywords: 'Midjourney, Midjourney AI, مولد فن AI, صور AI فنية, Midjourney مجاني, بديل Midjourney, كيفية استخدام Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 مولد فيديو الذكاء الاصطناعي | WeryAI',
        description: 'أنشئ فيديوهات مذهلة مع Runway Gen-4.5 على WeryAI. معمارية هجينة انتشارية ذاتية الانحدار لمحاكاة فيزيائية دقيقة واتساق زمني.',
        keywords: 'Runway Gen-4.5, مولد فيديو الذكاء الاصطناعي, فيديو سينمائي بالذكاء الاصطناعي, محاكاة فيزيائية, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro مولد فيديو الذكاء الاصطناعي | WeryAI',
        description: 'أنشئ فيديوهات عالية الجودة مع Kling 2.6 Pro على WeryAI. توليد سمعي بصري أصلي، جودة سينمائية 1080p، التزام ممتاز بالنصوص.',
        keywords: 'Kling 2.6 Pro, مولد فيديو الذكاء الاصطناعي, فيديو عالي الجودة بالذكاء الاصطناعي, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 مولد فيديو تحكم دقيق بالكاميرا وتوجيه | WeryAI',
        description: 'أنشئ فيديوهات سينمائية بالذكاء الاصطناعي مع Dreamina 3.0 (Jimeng 3.0) على WeryAI. تحكم دقيق بإطارات البداية/النهاية، حركات كاميرا احترافية وتوليد فيديو 1080p عالي الديناميكية.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, مولد فيديو الذكاء الاصطناعي, تحكم الكاميرا, إطارات البداية النهاية, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 مولد فيديو الذكاء الاصطناعي | WeryAI',
        description: 'أطلق إبداعك على WeryAI مع مولد فيديو الذكاء الاصطناعي Kling O1. مثالي لإنشاء محتوى فيديو خيالي وفريد.',
        keywords: 'Kling O1, مولد فيديو الذكاء الاصطناعي, فيديو إبداعي بالذكاء الاصطناعي, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - مولد فيديو ذكاء اصطناعي ذكي | WeryAI',

        description: 'أنشئ فيديوهات AI مع Kling 3.0: لوحة قصة ذكية، مزامنة شفاه متعددة اللغات، وعرض نصي دقيق. مجاناً على WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, مولد فيديو AI, لوحة قصة ذكية, مزامنة شفاه, عرض نصي, نص إلى فيديو, صورة إلى فيديو, فيديو AI مجاني, WeryAI',

        og_title: 'Kling 3.0 - مولد فيديو ذكاء اصطناعي ذكي | WeryAI',

        og_description: 'أنشئ فيديوهات AI مع Kling 3.0: لوحة قصة ذكية، مزامنة شفاه متعددة اللغات، وعرض نصي دقيق. مجاناً على WeryAI.',

        twitter_title: 'Kling 3.0 - مولد فيديو ذكاء اصطناعي ذكي | WeryAI',

        twitter_description: 'أنشئ فيديوهات AI مع Kling 3.0: لوحة قصة ذكية، مزامنة شفاه متعددة اللغات، وعرض نصي دقيق. مجاناً على WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - مولد صوت وفيديو أصلي 16 ثانية | WeryAI',

        description: 'ولّد صوت وفيديو أصلي 16 ثانية مع Vidu Q3: قص ذكي، عرض نصي دقيق، ومزامنة شفاه متعددة اللغات. مجاناً على WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, مولد فيديو AI, صوت وفيديو أصلي 16 ثانية, لوحة قصة ذكية, عرض نصي, مزامنة شفاه, نص إلى فيديو, صورة إلى فيديو, فيديو AI مجاني, WeryAI',

        og_title: 'Vidu Q3 - مولد صوت وفيديو أصلي 16 ثانية | WeryAI',

        og_description: 'ولّد صوت وفيديو أصلي 16 ثانية مع Vidu Q3: قص ذكي، عرض نصي دقيق، ومزامنة شفاه متعددة اللغات. مجاناً على WeryAI.',

        twitter_title: 'Vidu Q3 - مولد صوت وفيديو أصلي 16 ثانية | WeryAI',

        twitter_description: 'ولّد صوت وفيديو أصلي 16 ثانية مع Vidu Q3: قص ذكي، عرض نصي دقيق، ومزامنة شفاه متعددة اللغات. مجاناً على WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'مجاني GPT-4o - مولد صور OpenAI | WeryAI',
        description: 'استخدم GPT-4o على WeryAI لإنشاء صور عبر المحادثة! AI من OpenAI مع عرض نص دقيق ونتائج عالية الدقة. رصيد مجاني، بدون بطاقة.',
        keywords: 'GPT-4o, GPT-4o صورة, مولد صور OpenAI, فن AI حواري, GPT-4o مجاني, كيفية استخدام GPT-4o صور, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'مجاني GPT Image 1.5 - مولد فن OpenAI | WeryAI',
        description: 'استخدم GPT Image 1.5 على WeryAI لفن AI من الجيل القادم! أحدث نموذج OpenAI مع إبداع وتفاصيل محسّنة. رصيد مجاني، بدون بطاقة.',
        keywords: 'GPT Image 1.5, نموذج صور OpenAI, مولد فن AI, AI الجيل القادم, GPT Image 1.5 مجاني, كيفية استخدام GPT Image 1.5, WeryAI',
    },
    heygen_ai: {
        title: 'مولد فيديو HeyGen AI - منصة المقدم الافتراضي AI | WeryAI',
        description: 'جرّب مولد فيديو HeyGen AI المتخصص في فيديوهات المقدم الافتراضي والتعليق الصوتي متعدد اللغات. أنشئ محتوى فيديو احترافي مع صور رمزية AI واقعية وكلام طبيعي. جرّبه مجاناً على WeryAI.',
        keywords: 'HeyGen AI, مولد فيديو AI, مقدم افتراضي, تعليق صوتي AI, إنتاج فيديو, فيديو AI مجاني, WeryAI',
        og_title: 'مولد فيديو HeyGen AI - منصة المقدم الافتراضي AI | WeryAI',
        og_description: 'أنشئ فيديوهات احترافية للمقدم الافتراضي مع HeyGen AI. صور رمزية AI واقعية، تعليق صوتي متعدد اللغات وكلام طبيعي. جرّبه مجاناً على WeryAI.',
        twitter_title: 'مولد فيديو HeyGen AI - منصة المقدم الافتراضي AI | WeryAI',
        twitter_description: 'أنشئ فيديوهات احترافية للمقدم الافتراضي مع HeyGen AI. صور رمزية AI واقعية، تعليق صوتي متعدد اللغات وكلام طبيعي. جرّبه مجاناً على WeryAI.',
    },
    higgsfield_ai: {
        title: 'مولد فيديو Higgsfield AI - التحكم السينمائي بالكاميرا | WeryAI',
        description: 'جرّب مولد فيديو Higgsfield AI المتخصص في التحكم السينمائي بالكاميرا والسرد البصري. أنشئ محتوى فيديو AI بجودة المخرج مع توجيه دقيق للكاميرا. جرّبه مجاناً على WeryAI.',
        keywords: 'Higgsfield AI, مولد فيديو AI, فيديو سينمائي, التحكم بالكاميرا, إنتاج فيديو, فيديو AI مجاني, WeryAI',
        og_title: 'مولد فيديو Higgsfield AI - التحكم السينمائي بالكاميرا | WeryAI',
        og_description: 'أنشئ فيديوهات AI سينمائية مع Higgsfield AI. تحكم دقيق بالكاميرا، سرد بصري ومخرجات بجودة المخرج. جرّبه مجاناً على WeryAI.',
        twitter_title: 'مولد فيديو Higgsfield AI - التحكم السينمائي بالكاميرا | WeryAI',
        twitter_description: 'أنشئ فيديوهات AI سينمائية مع Higgsfield AI. تحكم دقيق بالكاميرا، سرد بصري ومخرجات بجودة المخرج. جرّبه مجاناً على WeryAI.',
    },
    invideo_ai: {
        title: 'مولد فيديو InVideo AI - منصة تحرير الفيديو الذكي | WeryAI',
        description: 'جرّب مولد فيديو InVideo AI المتخصص في تحرير الفيديو الذكي وإنشاء المحتوى الآلي. أنشئ فيديوهات احترافية من خلال تعليمات اللغة الطبيعية. جرّبه مجاناً على WeryAI.',
        keywords: 'InVideo AI, مولد فيديو AI, تحرير فيديو ذكي, إنشاء آلي, إنتاج فيديو, فيديو AI مجاني, WeryAI',
        og_title: 'مولد فيديو InVideo AI - تحرير الفيديو الذكي | WeryAI',
        og_description: 'أنشئ فيديوهات احترافية مع InVideo AI باستخدام تعليمات اللغة الطبيعية. تحرير ذكي وإنشاء محتوى آلي. جرّبه مجاناً على WeryAI.',
        twitter_title: 'مولد فيديو InVideo AI - تحرير الفيديو الذكي | WeryAI',
        twitter_description: 'أنشئ فيديوهات احترافية مع InVideo AI باستخدام تعليمات اللغة الطبيعية. تحرير ذكي وإنشاء محتوى آلي. جرّبه مجاناً على WeryAI.',
    },
    luma_dream_machine: {
        title: 'مولد فيديو Luma Dream Machine - إنشاء فيديو AI حالم | WeryAI',
        description: 'جرّب مولد فيديو Luma Dream Machine المتخصص في المؤثرات البصرية الحالمة وإنشاء الفيديو الإبداعي. أنشئ محتوى فيديو خيالي ومبدع بتقنية AI القوية. جرّبه مجاناً على WeryAI.',
        keywords: 'Luma Dream Machine, مولد فيديو AI, فيديو حالم, فيديو إبداعي, إنتاج فيديو, فيديو AI مجاني, WeryAI',
        og_title: 'مولد فيديو Luma Dream Machine - فيديو AI حالم | WeryAI',
        og_description: 'أنشئ فيديوهات AI خيالية وحالمة مع Luma Dream Machine. مؤثرات بصرية قوية وإنشاء محتوى إبداعي. جرّبه مجاناً على WeryAI.',
        twitter_title: 'مولد فيديو Luma Dream Machine - فيديو AI حالم | WeryAI',
        twitter_description: 'أنشئ فيديوهات AI خيالية وحالمة مع Luma Dream Machine. مؤثرات بصرية قوية وإنشاء محتوى إبداعي. جرّبه مجاناً على WeryAI.',
    },
    leonardo_ai: {
        title: 'مولد صور Leonardo AI - من التوجيه الفني إلى النظام البصري | WeryAI',
        description: 'جرّب مولد صور Leonardo AI، حوّل التوجيه الفني إلى نظام بصري متطور، وأنشئ لغة بصرية متسقة للشخصيات والمنتجات والحملات. جرّبه مجاناً على WeryAI.',
        keywords: 'Leonardo AI, مولد صور AI, فن مفاهيمي, تصميم شخصيات, إنشاء صور, صور AI مجانية, WeryAI',
        og_title: 'مولد صور Leonardo AI - من التوجيه الفني إلى النظام البصري | WeryAI',
        og_description: 'حوّل التوجيه الفني إلى نظام بصري متطور مع Leonardo AI. تصميم شخصيات متسق، فن مفاهيمي ومرئيات الحملات. جرّبه مجاناً على WeryAI.',
        twitter_title: 'مولد صور Leonardo AI - من التوجيه الفني إلى النظام البصري | WeryAI',
        twitter_description: 'حوّل التوجيه الفني إلى نظام بصري متطور مع Leonardo AI. تصميم شخصيات متسق، فن مفاهيمي ومرئيات الحملات. جرّبه مجاناً على WeryAI.',
    },
    soulgen_ai: {
        title: 'مولد صور SoulGen AI - مفهوم الشخصية بمنظور مميز | WeryAI',
        description: 'جرّب مولد صور SoulGen AI، امنح مفاهيم الشخصيات وجهة نظر مميزة. أنشئ صوراً معبّرة من ملاحظات الشخصيات والمراجع البصرية والأجواء. جرّبه مجاناً على WeryAI.',
        keywords: 'SoulGen AI, مولد شخصيات AI, تصميم شخصيات, إنشاء صور, صور AI مجانية, WeryAI',
        og_title: 'مولد صور SoulGen AI - إنشاء مفهوم الشخصية | WeryAI',
        og_description: 'امنح مفاهيم الشخصيات صوتاً بصرياً مميزاً مع SoulGen AI. أنشئ صوراً معبّرة من الشخصية والمراجع والأجواء. جرّبه مجاناً على WeryAI.',
        twitter_title: 'مولد صور SoulGen AI - إنشاء مفهوم الشخصية | WeryAI',
        twitter_description: 'امنح مفاهيم الشخصيات صوتاً بصرياً مميزاً مع SoulGen AI. أنشئ صوراً معبّرة من الشخصية والمراجع والأجواء. جرّبه مجاناً على WeryAI.',
    },
    stable_diffusion: {
        title: 'مولد صور Stable Diffusion - فن AI مفتوح المصدر | WeryAI',
        description: 'جرّب مولد صور Stable Diffusion، أداة توليد صور AI مفتوحة المصدر وقوية. أنشئ أعمالاً فنية AI فريدة من خلال تحكم مرن وأساليب متنوعة. جرّبه مجاناً على WeryAI.',
        keywords: 'Stable Diffusion, مولد صور AI, AI مفتوح المصدر, توليد صور, فن AI, صور AI مجانية, WeryAI',
        og_title: 'مولد صور Stable Diffusion - فن AI مفتوح المصدر | WeryAI',
        og_description: 'أنشئ أعمالاً فنية AI فريدة مع أدوات التحكم المرنة والأساليب المتنوعة لـ Stable Diffusion. مفتوح المصدر وقوي. جرّبه مجاناً على WeryAI.',
        twitter_title: 'مولد صور Stable Diffusion - فن AI مفتوح المصدر | WeryAI',
        twitter_description: 'أنشئ أعمالاً فنية AI فريدة مع أدوات التحكم المرنة والأساليب المتنوعة لـ Stable Diffusion. مفتوح المصدر وقوي. جرّبه مجاناً على WeryAI.',
    },
}
